import * as tslib_1 from "tslib";
import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/store';
export default mutatorAction('setCategory', function setCategory(categoryKey, subcategoryKey, currentOptionKey) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var store;
        return tslib_1.__generator(this, function (_a) {
            store = getStore();
            store.currentCategoryKey = categoryKey;
            store.currentSubCategoryKey = subcategoryKey;
            store.currentOptionKey = currentOptionKey;
            return [2 /*return*/];
        });
    });
});
//# sourceMappingURL=setCategory.js.map